const cancel = 'Törlés'
const save = 'Mentés'

export default {

  global: {
    generalError: 'Ajjaj! A kérést nem lehet feldolgozni. Töltse be ismét az oldalt.',
    signature: 'Üdvözlettel:',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Önéletrajz vagy más csatolmány hozzáadása',
      placeholderWithDescription: 'Adja hozzá a kért csatolmányokat',
      remove: 'Eltávolítás',
      allowedFileTypes: 'Engedélyezett fájltípusok',
      errors: {
        size: 'Túl nagy fájl, a legnagyobb fájlméret 5MB',
        empty: 'A fájl nem tartalmaz adatot',
        invalidType: fileType => `Sajnos a ${fileType} fájlok biztonsági okokból nem engedélyezettek`,
        typeNotWhitelisted: 'Sajnáljuk, ez a fájltípus nem engedélyezett.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Adatvédelmi irányelveket',
      termsLinkText: 'Általános szerződési feltételeket',
      privacyPolicyText:
        'Az Ön személyes adatainak biztonsága fontos számunka. Kérjük olvassa el az ',
      termsText1: 'Olvassa és fogadja el: ',
      termsText2: 'mielőtt megadja nekünk a személyes adatait.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Ha nem akarja, hogy személyes adatait feldolgozzuk, kérheti azok eltávolítását: küldjön üzenetet ide: ${mail}.`,
      customSupportPrivacyInfo: link => `Ha nem akarja, hogy személyes adatait feldolgozzuk, az eltávolítást a következő elérhetőségen kérheti: ${link}.`,
    },

    buttons: {
      close: 'Bezárás',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Igénylés eltávolítása',
      confirm: 'Próbálja meg ismét',
    },

    confirmButton: {
      wait: count => `Várakozás${count}`,
      confirm: 'Megerősítés',
    },

    controlStatus: {
      text: {
        empty: 'Kitöltés',
        valid: () => 'Kész',
      },
      textarea: {
        empty: 'Kitöltés',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Beállítás',
        valid: () => 'Kész',
      },
      file: {
        empty: 'Kiválasztás',
        valid: () => 'Megváltoztatás',
      },
      list: {
        empty: 'Hozzáadás',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Keresés',
        valid: () => 'Kész',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Eltávolítás',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Letiltva',
      content: 'A szerverünk udvariasan (de határozottan) elutasította az Ön böngészője kérésének teljesítését. Figyeljen arra, hogy a Recright használata (egyszerre) csak egy eszközzel/böngészővel lehetséges.',
      link: 'Címoldal',
    },

    error404: {
      heading: 'Üres',
      content: 'Keressük, de a megadott címen nem található honlap. Lehet, hogy a link lejárt, vagy véletlenül rossz címet adott meg.',
      link: 'Címoldal',
    },

    error410: {
      heading: 'Lezárva',
      content: 'Az állás nem jeleníthető meg, vagy azért, mert már le van zárva, vagy a jelentkezési határidő lejárt.',
      link: 'Címoldal',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    cookieConsentModal: {
      title: 'A weboldalunk sütiket (cookie) használ.',
      body: 'A sütik elfogadásával Ön hozzájárul ahhoz, hogy a sütiket az eszközén tároljuk az oldalon történő navigáció javítása, az oldalhasználat elemzése, és a marketingtevékenységeink támogatása érdekében.',
      learnMoreLinkText: 'További információ a sütik használatáról',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Sütik kezelése',
      acceptAll: 'Összes süti elfogadása',
      manageTitle: 'Hozzájárulási beállítások kezelése',
      necessaryCookiesTitle: 'Szükséges sütik',
      necessaryCookiesBody:
        'Ezek a sütik szükségesek a weboldal működéséhez, és nem kapcsolhatók ki rendszereinkben.',
      performanceCookiesTitle: 'Teljesítmény célú sütik',
      performanceCookiesBody:
        'Ezeknek a sütiknek a segítségével számláljuk a látogatásokat és a forgalmi forrásokat, így mérni és fejleszteni tudjuk az oldalunk teljesítményét.',
      confirmChoices: 'Választásaim megerősítése',
      marketingCookiesTitle: 'Marketing célú sütik',
      marketingCookiesBody:
        'Ezeknek a sütiknek a segítségével személyre szabhatjuk a hirdetéseket, és mérhetjük azok teljesítményét.',
      functionalCookiesTitle: 'Funkcionális sütik',
      functionalCookiesBody:
        'Ezek a sütik a weboldal funkcionalitásának javítására szolgálnak. Ezen sütik nélkül bizonyos funkciók elérhetetlenné válhatnak. A funkcionális sütik közé tartoznak például a webes csevegési szolgáltatások és a felhasználói beállítások.',
    },

    flash: {
      starting: 'Kezdeményezés...',
      connection_error_hint: 'Nem lehetett hálózati kapcsolatot létrehozni.\nPróbálja meg ismét betölteni az oldalt.',
      permission_hint: 'Engedélyeznie kell a honlap számára a webkamerája és a mikrofonja használatát.',
      searching_camera_hint: 'Webkamera keresése...',
      camera_reserved_hint: 'A webkamerát másik alkalmazás használja.\nKérjük, zárja be azt az alkalmazást és töltse be ismét ezt az oldalt.',
      camera_reserved_hint_chrome_extra: 'Kedves Chrome felhasználó, engedélyeznie kell a Recright számára a webkamera használatát a címsorban a párbeszédpanel alatt.',
      no_camera_hint: 'A webkamera nem található.',
      no_mic_hint: 'A mikrofon nem található.',
      uploading_text: 'Betöltés...',
      rtmpt_in_use: 'Erre a lépésre nincs szükség, ha hálózati rendszergazdája engedélyezi az RTMP protokollt. Mi megmondjuk, hogyan.',
      preview_text: 'A webkamera előnézeti módban van.',
      close_text: 'Kamera bezárása.',
      remove_text: 'Igénylés eltávolítása',
      noflash_errortext_install: link => `A gépén nincs telepítve az Adobe Flash Player. Szüksége lesz flash bővítőmodulra a videók rögzítéséhez. Itt tudja letölteni: ${link}`,
      noflash_errortext_enable: link => `Ha már letöltötte, és ugyanazt az üzenetet kapja, nézzen utána itt: ${link}`,
      noflash_errortext_differentbrowser: 'Esetleg használjon olyan böngészőt, ami engedélyezi a HTML5 rögzítést. Javasoljuk, hogy ez legyen Chrome, vagy Firefox.',
    },

    footer: {
      terms: 'Feltételek',
      license: 'General Terms of Service',
      privacyPolicy: 'Adatvédelmi szabályzat',
      customSupport: link => `Kapcsolat: ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Hogyan értékelné az interjú során szerzett tapasztalatait?',
      howWouldYouRateJobAd: 'Hogyan értékeli a jelentkezés során szerzett tapasztalatait?',
      yourResponseIsAnonymous: 'Válaszadása névtelen.',
      thankYouFeedback: 'Köszönjük visszajelzését!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Sajnáljuk, ez a fájltípus nem engedélyezett.',
      isRequired: 'A mező kitöltése kötelező.',
      isEmail: value => `${value} nem érvényes e-mail.`,
      isDate: value => `${value} nem érvényes dátum.`,
      invalidUrl: 'Érvénytelen URL',
      singleHireEndError: 'Egyszeri felvétel csak legfeljebb 60 napig használható.',
      isNotTooOldForLive: 'A dátum már eltelt.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Név',
      city: 'Lakóhely szerinti város',
      email: 'E-mail',
      phone: 'Telefonszám',
      applyForPosition: 'Jelentkezés a munkakörre',
      back: 'Vissza',
      continue: 'Folytatás',
      submit: 'Elküldés',
      saveForLater: 'Később folytatom',
      namePlaceholder: 'Adja meg a nevét',
      emailPlaceholder: 'Adja meg e-mail címét',
      phonePlaceholder: 'Adja meg telefonszámát',
      cityPlaceholder: 'Adja meg jelenlegi lakhelyét',
      links: 'Link hozzáadása, például Linkedin profil',
      legendBasicInfo: 'Alapinformációk',
      legendLinks: 'Linkek',
      legendAttachments: 'Csatolmányok',
      legendAdditionalFields: 'További információk',
      coverLetter: 'Motivációs levél',
      attachments: 'Csatolmányok',
      introduction: 'Rövid bemutatkozás',
      thankYou: 'Köszönjük!',
      luck: 'Sok sikert!',
      close: 'Bezárás',
      required: 'A * csillaggal jelölt mezők kitöltése kötelező.',
    },

    jobAdContainer: {
      endTime: date => (date ? `érvényesség ideje: ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Jelentkezés az állásra',
    },

    jobAdQuickInterview: {
      back: 'Vissza',
      submit: 'Elküldés',
      saveForLater: 'Később folytatom',
      title: 'Gyors videó interjú',
      description: 'Hogy gyorsabban megismerhessük, kérjük, röviden válaszoljon interjú kérdésünkre. Adja bele személyiségét, legyen lelke a jelentkezésének.',
      requiredNote: 'Felhívjuk a figyelmét, hogy ez csak a jelentkezési folyamat egyik része, és a munkaerő-toborzó csak akkor kapja meg a jelentkezését, miután rögzítette válaszát.',
      reminderNote: 'Most azonnal rögzítheti válaszát, vagy folytathatja később, amikor e-mailben emlékeztetőt kap.',
    },

    jobAdRow: {
      responses: 'Alkalmazások',
      status: {
        open: 'Nyitva',
        filled: 'Kitöltve',
        cancelled: 'Törölve',
        done: 'Befejezve',
        close: 'Bezárás',
        draft: 'Bezárva (tervezet)',
        hidden: 'Elrejtve',
      },
    },

    interviewRow: {
      responses: 'Jelentkezők',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Tovább a LinkedIn profilhoz',
    },

    linkedInButton: {
      error: 'Hiba a profil megnyitása során. Kérjük, próbálja ismét.',
      buttonText: 'Jelentkezés LinkedInnel',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'LinkedIn profilja használatával is kitöltheti a jelentkezési lapot.',
      linkedInOr: 'Vagy',
      error: 'Hiba a profil megnyitása során. Kérjük, próbálja ismét.',
    },

    linkListInput: {
      addField: 'Hozzáadás',
      removeField: 'Eltávolítás',
      invalidUrl: 'Érvénytelen URL',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Betöltés...',
      saving: 'Mentés...',
      sending: 'Küldés...',
    },

    modalApplicationForm: {
      applyForPosition: 'Jelentkezés az állásra',
      continue: 'Folytatás',
      name: 'Adja meg a nevét',
      email: 'Adja meg e-mail címét',
      phoneNumber: 'Adja meg telefonszámát',
      links: 'Itt adhat meg linkeket',
      legendLinks: 'Linkek',
      legendAttachments: 'Csatolmányok',
      coverLetter: 'Motivációs levél',
      attachments: 'Csatolmányok.',
      introduction: 'Ide írja bemutatkozását',
      thankYou: 'Köszönjük!',
      luck: 'Sok sikert!',
      close: 'Bezárás',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Megosztható nyilvános link',
      info: 'Itt találja az álláshirdetés megosztható nyilvános címét.\nBárki, akit érdekel az állás, láthatja azt, és döntése\nszerint jelentkezhet.\nÖn a szokásos értesítést fogja kapni, amikor a jelentkezések elkezdenek beérkezni.\n\nAz álláshirdetés nyilvános linkje:',
    },

    modalVideoAdd: {
      title: 'Új videó hozzáadása',
      chooseTitle: 'Új videó hozzáadása',
      titlePlaceholder: 'Videó címének megadása',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Új videó feltöltése',
      info: 'A legnagyobb megengedett videó méret 500 MB. Javasoljuk, hogy a videókat feltöltés előtt tömörítse, így a feltöltés és az átalakítás rövidebb ideig fog tartani.',
    },

    modalCandidateInfo: [
      {
        headline: 'Videó válaszát olyan gyakran ',
        content: 'rögzítheti, amilyen gyakran szeretné. A videók mentése rögtön a rögzítés után megtörténik, és Ön az e-mailben kapott link használatával bármikor visszaérhet a videó interjúhoz.',
        mobileContent: 'amilyen gyakran szeretné. Adja hozzá a videót az interjúhoz. Látni fogja, ahogy a videó feltöltődik, és elmentésre kerül az interjúban. Ön az e-mailben kapott link használatával bármikor visszaérhet a videó interjúhoz. <br><br><strong>Ha a videó képernyője fekete marad és Ön Apple mobil eszközt használ, a probléma megoldását <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">itt találja</a>.</strong>',
      },
      {
        headline: 'Rögzítés után ',
        content: 'bizonyosodjon meg arról, hogy a videó megfelelően lejátszható, és a hangja hallható. A „Küldés” gomb megnyomásával a válasza zárolva lesz, és azon túl már nem szerkeszthető.',
      },
      {
        headline: 'Ha befejezte az interjút, ',
        content: 'kérjük, nyomja meg a „Válaszok küldése és interjú befejezése” gombot. Ezután már nem térhet vissza a videó interjúhoz. Ha szeretné bezárni az oldalt, de később szeretné folytatni az interjút, nyomja meg a „Folytatás később” gombot.',
      },
      {
        headline: 'Ha segítségre van szüksége ',
        content: mailto => `a videó interjú kérdéseinek megválaszolása során, kattintson a „Segítség” gombra az oldal jobb alsó szélén, vagy küldjön nekünk e-mailt erre a címre: ${mailto}.`,
        customContent: link => `Kapcsolat: ${link}`,
      },
    ],

    navigationBar: {
      back: 'Vissza',
      dashboard: 'Dashboard',
      frontpage: 'Címoldal',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefonszám formátum ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Átlagos értékelés',
      reset: 'visszaállítás',
    },

    share: {
      share: 'Megosztás',
      copy: 'Link másolása',
    },

    sort: {
      sort: 'Kiválasztás',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Kiválasztva',
      change: 'Megváltoztatás erre',
    },

    video: {
      videoNotFound: 'A videó feldolgozás alatt, vagy a videó nem található',
      retry: 'Próbálja meg ismét',
      originalLanguageLabel: 'Eredeti',
      englishLanguageLabel: 'Angol',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Új videó feltöltése, vagy rögzítése' : 'Fájl kiválasztása'),
      videoPlaceholder: 'Válasza rögzítése',
      uploadPlaceholderCandidate: 'Videó feltöltése',
      submit: 'Válasz beküldése',
      notAnswered: 'Még nem válaszolt',
      remove: 'Igénylés eltávolítása',
      converting: 'Videó átalakítása. Kérjük, várjon...',
      uploading: 'Videó feltöltése. Kérjük, várjon...',
      error: {
        invalid: 'A kiválasztott fájl túl nagy. Kérjük, válasszon másik fájlt.',
        upload: 'Elnézését kérjük, de nem sikerült feltölteni a videót. Kérjük, próbálja meg ismét.',
        transcode: 'A kiválasztott videó fájl sérült, vagy érvénytelen, kérjük, próbálja meg ismét.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Több megjelenítése',
      showLessButtonText: 'Kevesebb megjelenítése',
      infoText1:
        'Felvétel készítése közben tartsa a lapot aktívan az előtérben. Felvétel készítése közben ne használjon más alkalmazást.',
      infoText2:
        'A videóháttér akkor működik a legjobban, ha a legújabb böngészőket használja, és ha az eszköz viszonylag új és erős.',
      infoText3:
        'Győződjön meg róla, hogy más alkalmazások nem használják a mikrofonját vagy a kameráját.',
    },

    videoResponse: {
      videoPlaceholder: 'Válaszai rögzítése',
      uploadPlaceholder: 'Videó feltöltése',
      submit: 'Válasz elküldése',
      notAnswered: 'Még nem válaszolt',
      required: 'Ez a kérdés választ igényel',
      startInterview: 'Interjú indítása',
    },

    webcam: {
      useVideoBgButtonText: 'Videóháttér használata',
      removeVideoBgButtonText: 'Videóháttér eltávolítása',
      starting: 'Indítás...',
      close: 'Kamera bezárása',
      remove: 'Igénylés eltávolítása',
      record: 'Rögzítés',
      stop: 'Megállítás',
      retake: 'Interjú megismétlése',
      submit: 'Válasz elküldése',
      converting: 'Videó átalakítása. Kérjük, várjon...',
      uploading: 'Videó feltöltése. Kérjük, várjon...',
      downloading: 'Videó letöltése. Kérjük, várjon...',
      processing: 'Feldolgozás...',
      uploadInProgress: 'A videó átvitele folyamatban van, ne zárja be a böngészőt, és ne váltson másik oldalra.',
      uploaded: 'A videó átvitele sikeres.',
      error: {
        DevicesNotFoundError: 'A kamera vagy a mikrofon nem használható.Ellenőrizze, hogy engedélyezve vannak-e.',
        NotFoundError: 'A kamera vagy a mikrofon nem használható.Ellenőrizze, hogy engedélyezve vannak-e.',
        NotAllowedError: 'Nem adott engedélyt a kamera, vagy a mikrofon használatára.',
        PermissionDismissedError: 'Elutasította az engedélyezést. Kérjük, engedélyezze a kamera és a mikrofon használatát.',
        PermissionDeniedError: 'Letiltotta a hozzáférést a kamerához vagy a mikrofonhoz.',
        NotReadableError: 'A kamera vagy a mikrofon folyam nem olvasható. Lehetséges hardver probléma.',
        SecurityError: 'Biztonsági hiba miatt nem használható a kamera, vagy a mikrofon.',
        stream: 'Hiba történt. Indítsa újra böngészőjét. Ha a hiba továbbra is fennáll, próbáljon meg másik böngészőt használni.',
        download: 'A videó letöltése meghiúsult. Megpróbálja ismét?',
        upload: 'A videó feltöltése meghiúsult. Megpróbálja ismét?',
        emptyBlob: 'A böngésző memóriája megtelt, így nem képes a rögzítésre. Kérjük, frissítse az oldalt, és ha nem oldódik meg a probléma, indítsa újra a böngészőt. Ha a probléma továbbra is fennáll, próbáljon meg másik böngészőt használni.',
        alternativeRecorder: 'A fájl feltöltését erre kattintva is elkészítheti.',
        reconnecting: 'A kapcsolat megszakadt. Újracsatlakozás folyamatban.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Üdvözöljük! Szeretnénk meghívni Önt egy, a(z) ${title} pozícióval kapcsolatos videóinterjúra! Ezt a meghívót az Ön e-mail címére is elküldtük. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
